export default __webpack_public_path__ + "static/media/bro.abfeb20e.png";